class RecipeCollectionCardGroup {
    init() {
        const widgets = document.querySelectorAll('.js-recipe-collection-card-group');

        widgets.forEach(widget => this.initWidget(widget));
    }

    initWidget(widget) {
        const track = widget.querySelector('.js-recipe-collection-card-group-track');
        const previousButton = widget.querySelector('.js-recipe-collection-card-group-prev');
        const nextButton = widget.querySelector('.js-recipe-collection-card-group-next');

        if (!track || !previousButton || !nextButton) {
            return;
        }

        const updateButtons = () => {
            const maxScrollLeft = track.scrollWidth - track.clientWidth;

            previousButton.disabled = track.scrollLeft <= 30;
            nextButton.disabled = track.scrollLeft >= maxScrollLeft - 1;
        };

        const scrollCards = direction => {
            const firstCard = track.querySelector('.recipe-collection-card-group-card');
            const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : track.clientWidth;
            const gap = 24;

            track.scrollBy({
                left: direction * (cardWidth + gap),
                behavior: 'smooth'
            });
        };

        previousButton.addEventListener('click', () => scrollCards(-1));
        nextButton.addEventListener('click', () => scrollCards(1));
        track.addEventListener('scroll', updateButtons);
        window.addEventListener('resize', updateButtons);

        updateButtons();
    }
}

export default RecipeCollectionCardGroup;

document.addEventListener('DOMContentLoaded', () => {
    const recipeCollectionCardGroup = new RecipeCollectionCardGroup();
    recipeCollectionCardGroup.init();
});
